import React, { FC } from 'react';
import { TableCell, Box, Tooltip } from '@mui/material';
import Moment from 'react-moment';
import { CertificateIcon } from 'assets/img/menu';
import {
  Date,
  StyledCell,
  TableRow,
  OpacityContainer,
  IconContainer,
  StyledIconButton,
} from './styles';
import { ImpactClaim, ImpactClaimStatus } from 'FeatureModules/Request/types/impactClaim.types';
import { TableAction } from './ImpactClaimTable';
import ClaimTitleAndStatus from '../ClaimTitleAndStatus';
import LevelPill from '../LevelPill';
import { ImpactLevelCategories } from 'FeatureModules/ImpactClaim/utils/impactLevelCategories';

interface IImpactClaimTableRowProps {
  impactClaim: ImpactClaim;
  actions?: TableAction[];
  titleWidth?: number;
  hasShadow?: boolean;
  onSelect: (id: string) => void;
}

const ImpactClaimTableRow: FC<IImpactClaimTableRowProps> = ({
  impactClaim,
  actions,
  titleWidth = 450,
  hasShadow = true,
  onSelect,
}) => {
  const {
    id,
    createdTimestamp,
    attachmentCount,
    impactCatalogItem,
    status,
    isInvalid,
    impactLevel,
    impactLevelTitle,
  } = impactClaim;
  const labelId = `impact-claim-table-${id}`;
  const claimLevel = ImpactLevelCategories[impactLevel];
  const transparent = status === ImpactClaimStatus.REQUESTED;

  return (
    <TableRow
      data-testid="impact-claim-table-item"
      hover
      transparent={transparent}
      hasShadow={hasShadow}
      isInvalid={isInvalid}
      key={id}
      onClick={(event: { stopPropagation: () => void }) => {
        event.stopPropagation();
        onSelect(impactClaim.id);
      }}
    >
      <StyledCell id={labelId} scope="row" width={titleWidth}>
        <ClaimTitleAndStatus
          impactCatalogItem={impactCatalogItem}
          transparent={transparent}
          claimStatus={status}
          showSeeComments
        />
      </StyledCell>
      <TableCell width={300} id={labelId} scope="row">
        <OpacityContainer transparent={transparent}>
          <LevelPill claimLevel={claimLevel} title={impactLevelTitle} />
        </OpacityContainer>
      </TableCell>
      <TableCell width={200} id={labelId} scope="row">
        <Box display="flex">
          <CertificateIcon />
          <Box pl={1}>
            {attachmentCount} proof document
            {attachmentCount !== 1 ? 's' : ''}
          </Box>
        </Box>
      </TableCell>
      <TableCell id={labelId} scope="row">
        <Date variant="subtitle2">
          <Moment format="LL">{createdTimestamp}</Moment>
        </Date>
      </TableCell>
      <TableCell width={50} id={labelId} scope="row" align="right">
        {actions && actions.length > 0 && (
          <IconContainer>
            {actions.map((action, index) => {
              return (
                <Tooltip key={index} title={action.tooltip}>
                  <StyledIconButton
                    data-testid={action.dataCy}
                    onClick={event => {
                      event.stopPropagation();
                      action.onClick(impactClaim);
                    }}
                  >
                    {action.icon}
                  </StyledIconButton>
                </Tooltip>
              );
            })}
          </IconContainer>
        )}
      </TableCell>
    </TableRow>
  );
};

export default ImpactClaimTableRow;
